export default __webpack_public_path__ + "static/media/THSarabun.0129e54e.ttf";